export default __webpack_public_path__ + "static/media/background-portal-3.2005bcd2.svg";